import React  from "react";
import { useParams } from 'react-router-dom';
import HolidayForm from "./components/HolidayForm";
import Card from "components/card";

const ViewHoliday = () => {
	const { holidayId } = useParams();
    
	return (
	    <div className="mt-3">
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<Card extra={"w-full h-full p-4"}>
					<HolidayForm recordId={holidayId} mode="view"/>
				</Card>
	      	</div>
	    </div>
    );
};

export default ViewHoliday;